(function() {
	const planBtn = document.getElementById("plan-details-btn");
	planBtn.addEventListener("click", function() {
		const details = document.getElementsByClassName("js-plan-details");
		const height = getHeight(details);				
		const oldText = this.textContent.trim();

		this.innerHTML = this.innerHTML.replace(oldText, this.dataset.altText);
		this.dataset.altText = oldText;

		if (this.dataset.status == 0) {
			
			this.dataset.status = 1;
			this.firstElementChild.style.transform = "rotate(180deg)";
			
			for (let i = 0; i < details.length; i++) {
				details[i].style.maxHeight = `${height}px`;
			}
		}
		else {

			this.dataset.status = 0;
			this.firstElementChild.removeAttribute("style");

			for (let i = 0; i < details.length; i++) {
				details[i].removeAttribute("style");
			}
		}
	})

	function getHeight(cnts) {

		let height = 0;

		for (let i = 0; i < cnts.length; i++) {
			if (height < cnts[i].children[0].offsetHeight) {
				height = cnts[i].children[0].offsetHeight;
			}
		}

		return height;
	}
})();